import { useI18next } from 'gatsby-plugin-react-i18next'
import { defaultLanguage } from 'config/helpers'

const useLink = (): string => {
  const { language } = useI18next()
  const routerChange = language === defaultLanguage ? '' : '/' + language
  return routerChange
}

export default useLink
